/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAuthPhoneControllerVerifyCodeByPhoneMutationRequest,
  TelegramAuthPhoneControllerVerifyCodeByPhoneMutationResponse,
  TelegramAuthPhoneControllerVerifyCodeByPhone400,
  TelegramAuthPhoneControllerVerifyCodeByPhone401,
  TelegramAuthPhoneControllerVerifyCodeByPhone403,
  TelegramAuthPhoneControllerVerifyCodeByPhone429,
} from '../../types/TelegramAuthPhoneControllerVerifyCodeByPhone.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramAuthPhoneVerifyCodeByPhone } from '../../methods/telegramAuthPhoneVerifyCodeByPhone.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramAuthPhoneVerifyCodeByPhoneMutationKey = () =>
  [{ url: '/api/telegram/auth/phone/verify-code' }] as const;

export type TelegramAuthPhoneVerifyCodeByPhoneMutationKey = ReturnType<
  typeof telegramAuthPhoneVerifyCodeByPhoneMutationKey
>;

/**
 * {@link /api/telegram/auth/phone/verify-code}
 */
export function useTelegramAuthPhoneVerifyCodeByPhone<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramAuthPhoneControllerVerifyCodeByPhoneMutationResponse,
      ResponseErrorConfig<
        | TelegramAuthPhoneControllerVerifyCodeByPhone400
        | TelegramAuthPhoneControllerVerifyCodeByPhone401
        | TelegramAuthPhoneControllerVerifyCodeByPhone403
        | TelegramAuthPhoneControllerVerifyCodeByPhone429
      >,
      { data: TelegramAuthPhoneControllerVerifyCodeByPhoneMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramAuthPhoneControllerVerifyCodeByPhoneMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramAuthPhoneVerifyCodeByPhoneMutationKey();

  return useMutation<
    TelegramAuthPhoneControllerVerifyCodeByPhoneMutationResponse,
    ResponseErrorConfig<
      | TelegramAuthPhoneControllerVerifyCodeByPhone400
      | TelegramAuthPhoneControllerVerifyCodeByPhone401
      | TelegramAuthPhoneControllerVerifyCodeByPhone403
      | TelegramAuthPhoneControllerVerifyCodeByPhone429
    >,
    { data: TelegramAuthPhoneControllerVerifyCodeByPhoneMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramAuthPhoneVerifyCodeByPhone(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
